import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../views/Home/Home.vue'
import About from '../views/About/About.vue'
import Services from '../views/Services/Services.vue'
import Facilities from '../views/Facilities/Facilities.vue'
import Products from '../views/Products/Products.vue'
import Aeriopace from '../views/Products/Aeriopace.vue'
import Marine from '../views/Products/Marine.vue'
import Oilgas from '../views/Products/oilgas.vue'
import Power from '../views/Products/Power.vue'
import AirSeraration from '../views/Products/AirSeraration.vue'
import News from '../views/News/News.vue'
import Contacts from '../views/Contacts/Contacts.vue'


Vue.use(VueRouter)

var router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: Home,
    },
    {
      path: '/about',
      component: About,
    },
    {
      path: '/services',
      component: Services,
    },
    {
      path: '/facilities',
      component: Facilities,
    },
    {
      path: '/products',
      component: Products,
    },
    {
      path: '/news',
      component: News,
    },
    {
      path: '/contacts',
      component: Contacts,
    },
    {
      path: '/aeriopace',
      component: Aeriopace,
    },
    {
      path: '/marine',
      component: Marine,
    },
    {
      path: '/oilgas',
      component: Oilgas,
    },
    {
      path: '/airseraration',
      component: AirSeraration,
    },
    {
      path: '/power',
      component: Power,
    },

  ],
  mode: 'history',
  base:'/cadt',

})

// 经验证，这个路由守卫没什么用，因为vue-router在跳转的路径相同的时候，在执行这个路由守卫之前就拦截了
router.beforeEach((to, from, next) => {
  // console.log(to.path===from.path)
  // window.scrollTo(0,0);
  if (to.path === from.path) {

    console.log('路由相等啦')
    return
  } else {

    next()

  }
})


// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js